import * as Yup from 'yup'

const verificationCodeValidator = Yup.object ({
  verification_code: Yup
    .string ()
    .min (6, 'O código deve ter 6 dígitos')
})

export default verificationCodeValidator
